import {mainServer} from '../../../../../variables/config'

export const request_car = async (car_id) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response = await mainServer.instance.get(`/car/${car_id}`)
  return response.data.data.car
}

